import { create } from "zustand";
import { persist } from "zustand/middleware";
import DocumentReference, {
  BoundingBox,
} from "../models/conversation/document";

type DocumentReferenceState = {
  selectedBoundingBoxes: BoundingBox[];
  setSelectedBoundingBoxes: (boundingBoxes: BoundingBox[] | undefined) => void;
  selectedDocumentReference?: DocumentReference;
  setSelectedDocumentReference: (
    documentReference: DocumentReference | undefined
  ) => void;
  documentReferences: DocumentReference[];
  setDocumentReferences: (documentReferences: DocumentReference[]) => void;
  documentRefIdsOrdered: string[];
  setDocumentRefIdsOrdered: (documentRefIdsOrdered: string[]) => void;
  reset: () => void;
};

const initialState = {
  selectedBoundingBoxes: [],
  documentReferences: [],
  selectedDocumentReference: undefined,
  documentRefIdsOrdered: [],
};

export const useDocumentReferenceStore = create<DocumentReferenceState>()(
  persist(
    (set) => ({
      ...initialState,
      setSelectedBoundingBoxes: (boundingBoxes: BoundingBox[] | undefined) =>
        set((state) => {
          return { ...state, selectedBoundingBoxes: boundingBoxes || [] };
        }),
      setSelectedDocumentReference: (
        documentReference: DocumentReference | undefined
      ) =>
        set((state) => {
          return { ...state, selectedDocumentReference: documentReference };
        }),
      setDocumentReferences: (documentReferences: DocumentReference[]) =>
        set((state) => {
          return { ...state, documentReferences };
        }),
      setDocumentRefIdsOrdered: (documentRefIdsOrdered: string[]) =>
        set((state) => {
          return { ...state, documentRefIdsOrdered };
        }),
      reset: () => set(initialState),
    }),
    {
      name: "document-reference-storage",
    }
  )
);
